import React, { useEffect, useState } from 'react';
import { Outlet } from "react-router-dom";
import { Container } from 'reactstrap';
import Header from './Layout/Header';
import Menu  from './Layout/Menu';
import WizardMenu from './WizardMenu/WizardMenu';
import axios from 'axios';
import useAuth from "../components/Utilities/Hooks/useAuth";
import Footer from './Layout/Footer';
import LoginFooter from '../images/login_footer.png';

const Layout = (wizardDetails, pageReload) => {
    const { auth, setAuth } = useAuth();
    const [showWizard, setShowWizard] = useState(true);
    useEffect(() => {
        validateToken();
    }, [])
    const validateToken = async () => {
        if (auth != null) {
            let form = {
                Token: auth.token
            }
            const response = await axios.post(
                '/api/Token/Validate/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (!response.data) {
                window.open("/login", "_self");
            }
        }
        else {
            window.open("/login", "_self");
        }
    }
    const handleSetShowWizard = async () => {
        setShowWizard(!showWizard);
    }
    return (
        <main>
            {/*<Header />*/}
            <Menu handleSetShowWizard={handleSetShowWizard} />
            <div style={{ height: "82vh", overflow: "auto", marginBottom:"5vh" }}>
            {showWizard && <WizardMenu wizardDetails={wizardDetails} pageReload={pageReload} />}
                <Container className="layout-body">
                    <Outlet />
                </Container>
            </div>
            <div className="footerLogin" >
                <div style={{
                    backgroundImage: `url(${LoginFooter})`,
                    backgroundSize: 'unset',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right',
                    height: '5vh', marginTop: "-5px", marginRight: "10px"
                }}>
                </div>
            </div>
        </main>
    );
}

export default Layout